import Cookies from 'js-cookie';

// import { COOKIE_DOMAIN } from '../config';

export const setParameters = data => {
  Cookies.set('bsn_tkn', data.api_token, { expires: 30 });
  Cookies.set('jwt_token', data.jwt_token, { expires: 30 });
  Cookies.set('fingerprint', data.fingerprint, { expires: 30 });
  localStorage.removeItem('splitLinksAnalyticsColumns');
  localStorage.removeItem('usersAnalyticsColumns');
  localStorage.removeItem('campaignsAnalyticsColumns');
  localStorage.removeItem('splitLinksColumns');
  localStorage.removeItem('settings-default');
  localStorage.removeItem('api-url');
};